var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3006_9021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8H1.5C0.673 8 0 7.327 0 6.5V1.5C0 0.673 0.673 0 1.5 0H9.5C10.327 0 11 0.673 11 1.5V6.5C11 7.327 10.327 8 9.5 8ZM1.5 1C1.225 1 1 1.224 1 1.5V6.5C1 6.776 1.225 7 1.5 7H9.5C9.775 7 10 6.776 10 6.5V1.5C10 1.224 9.775 1 9.5 1H1.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 24H1.5C0.673 24 0 23.327 0 22.5V11.5C0 10.673 0.673 10 1.5 10H9.5C10.327 10 11 10.673 11 11.5V22.5C11 23.327 10.327 24 9.5 24ZM1.5 11C1.225 11 1 11.224 1 11.5V22.5C1 22.776 1.225 23 1.5 23H9.5C9.775 23 10 22.776 10 22.5V11.5C10 11.224 9.775 11 9.5 11H1.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 24H14.5C13.673 24 13 23.327 13 22.5V17.5C13 16.673 13.673 16 14.5 16H22.5C23.327 16 24 16.673 24 17.5V22.5C24 23.327 23.327 24 22.5 24ZM14.5 17C14.225 17 14 17.224 14 17.5V22.5C14 22.776 14.225 23 14.5 23H22.5C22.775 23 23 22.776 23 22.5V17.5C23 17.224 22.775 17 22.5 17H14.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 14H14.5C13.673 14 13 13.327 13 12.5V1.5C13 0.673 13.673 0 14.5 0H22.5C23.327 0 24 0.673 24 1.5V12.5C24 13.327 23.327 14 22.5 14ZM14.5 1C14.225 1 14 1.224 14 1.5V12.5C14 12.776 14.225 13 14.5 13H22.5C22.775 13 23 12.776 23 12.5V1.5C23 1.224 22.775 1 22.5 1H14.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3006_9021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.3341d6101ef77ddd9a5fb1094b74c255.svg";
export { ForwardRef as ReactComponent };